import { render, staticRenderFns } from "./Follow-Up.vue?vue&type=template&id=9c373ccc"
import script from "./Follow-Up.vue?vue&type=script&lang=js"
export * from "./Follow-Up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports